/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CatalogItemCompositionInput, CatalogItemId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getUpdateServiceCompositionUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}/composition`;
};

/**
 * @summary Replace service composition
 */
export const updateServiceComposition = async (
  id: CatalogItemId,
  catalogItemCompositionInput: CatalogItemCompositionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateServiceCompositionUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(catalogItemCompositionInput),
  });
};
